export enum MessageStatus {
  Loading = 'Loading',
  LoadingUpdate = 'LoadingUpdate',
  Streaming = 'Streaming',
  Loaded = 'Loaded',
  Failed = 'Failed'
}
